import { buildCollection } from "@firecms/core";
import { Button } from "@firecms/ui";

export const fieldCollection = buildCollection({
    id: "field",
    name: "Fields",
    icon: "settings",
    description: "Manage system-wide metadata fields, professional categories, and display orders.",
    path: "field",
    defaultSize: "xs",
    customId: true,
    properties: {
        created_at: {
            dataType: "date",
            name: "Created at",
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "date",
            name: "Updated at",
            autoValue: "on_update"
        },
        title: {
            dataType: "string",
            name: "Title",
            validation: { required: true }
        },
        description: {
            dataType: "string",
            name: "Description",
            multiline: true
        },
        values: {
            dataType: "array",
            name: "Values",
            of: {
                dataType: "string"
            },
            hideFromCollection: true
        },
        display_order: {
            dataType: "array",
            name: "Display Order",
            of: {
                dataType: "string"
            },
            hideFromCollection: true
        },
        key_lookup: {
            dataType: "map",
            name: "Key Lookup (legacy)",
            keyValue: true,
            hideFromCollection: true
        },
        key_lookups: {
            dataType: "map",
            name: "Key Lookups",
            keyValue: true,
            hideFromCollection: true
        },
        key_value: {
            dataType: "array",
            name: "Key Value",
            hideFromCollection: true,
            of: {
                dataType: "map",
                properties: {
                    key: { dataType: "string", name: "Key" },
                    label: { dataType: "string", name: "Label" },
                    function: { dataType: "string", name: "Function (parent slug)" }
                }
            }
        }
    },
    openEntityMode: "full_screen",
    additionalFields: [
        {
            key: "id",
            name: "ID",
            Builder: ({ entity }) => entity.id
        },
        {
            key: "edit",
            name: " ",
            Builder: ({ entity, context }: any) => (
                <Button variant="text" size="small" onClick={(e) => {
                    e.stopPropagation();
                    context.navigationController.navigate(`/c/field/${entity.id}`);
                }}>
                    Edit
                </Button>
            )
        }
    ],
    propertiesOrder: ["key_value", "id", "title", "description", "edit", "values", "display_order", "key_lookup", "key_lookups", "created_at", "updated_at"]
});
